// src/config.js
const config = {
    // BASE_URL: "http://localhost:5001",
    FRONTEND_BASE_URL: "http://localhost:3000",
    // BASE_URL: "http://160.153.172.188:5000",
    BASE_URL:"https://luminicos.com",
//    FRONTEND_BASE_URL: "http://localhost:3000",
};
  
export default config;
  